import { render } from "./ComponenteInformes.vue?vue&type=template&id=4f1e45d6&scoped=true"
import script from "./ComponenteInformes.vue?vue&type=script&lang=js"
export * from "./ComponenteInformes.vue?vue&type=script&lang=js"

import "./ComponenteInformes.vue?vue&type=style&index=0&id=4f1e45d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1e45d6"]])

export default __exports__